import partner01 from "../imgs/partner/partner01.png";
import partner02 from "../imgs/partner/partner02.png";
import partner03 from "../imgs/partner/partner03.png";
import partner04 from "../imgs/partner/partner04.png";
import partner05 from "../imgs/partner/partner05.png";
import partner06 from "../imgs/partner/partner06.png";
import partner07 from "../imgs/partner/partner07.png";
import partner08 from "../imgs/partner/partner08.png";
import partner09 from "../imgs/partner/partner09.png";
import partner10 from "../imgs/partner/partner10.png";

import partner11 from "../imgs/partner/partner11.png";
import partner12 from "../imgs/partner/partner12.png";
import partner13 from "../imgs/partner/partner13.png";
import partner14 from "../imgs/partner/partner14.png";
import partner15 from "../imgs/partner/partner15.png";
import partner16 from "../imgs/partner/partner16.png";
import partner17 from "../imgs/partner/partner17.png";
import partner18 from "../imgs/partner/partner18.png";
import partner19 from "../imgs/partner/partner19.png";

export const partnerImg = [
    partner01,
    partner02,
    partner03,
    partner04,
    partner05,
    partner06,
    partner07,
    partner08,
    partner09,
    partner10,
    partner11,
    partner12,
    partner13,
    partner14,
    partner15,
    partner16,
    partner17,
    partner18,
    partner19,
];
